import { render, staticRenderFns } from "./Poligono.vue?vue&type=template&id=45b0a7fa&"
import script from "./Poligono.vue?vue&type=script&lang=js&"
export * from "./Poligono.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports